<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline ps-2 pa-1">
                    {{ $t("seasonalPage.uploadTermsHeadline") }}
                  </div>
                </div>
              </v-card-title>
                <v-flex xs12 mt-3 grow class="full-width pa-4 pt-6 v-doc-form">
                  <upload-file
                    class="docs"
                    @change="model.file = $event"
                    :documentName="$t('seasonalPage.termsDocumentName')"
                  />
                <v-btn
                  :loading="loading"
                  block
                  @click="createTerms"
                  color="secondary"
                  dark
                  >{{ $t("seasonalPage.upload") }}</v-btn
                >
            </v-flex>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<style>
.docs {
  margin-bottom: 3px;
    text-align:center;
}
.v-doc-form{
    align-items: center;
    justify-content: center;
    display:grid;
}
</style>

<script>
import axios from "axios";
import UploadFile from "@/components/widgets/UploadFile.vue";

export default {
  title() {
    return this.$t("seasonalPage.createTermsPageTitle");
  },
  components: {
    UploadFile,
  },
  data: () => ({
    file: null,
    loading: false,
    model: {
        file:null,
    },

    rules: {
      email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
      length: (len) => (v) =>
        (v || "").length >= len || `Invalid character length, required ${len}`,
      password: (v) =>
        !!(v || "").match(/^.{8,15}$/) || "Password must be 8-15 characters.",

      required: (v) => !!v || "This field is required",
    },
  }),
  mounted() {},

  methods: {
    createTerms() {
      console.log(this.file);
        this.loading = true;
        const formData = new FormData();
        formData.append("file", this.model.file);
        this.axios
          .post(this.api.ACTIONS.TERMS, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("seasonalPage.termCreated"), "green");
            this.$router.push("/terms_and_conditions");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("seasonalPage.checkInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      console.log(this.file);
      // }
    },
  },
};
</script>
